import { createIndexedDBSuperstore } from 'superstore';
const storeInstances = new Map();
function getStore(namespace) {
  let instance = storeInstances.get(namespace);
  if (!instance) {
    instance = createIndexedDBSuperstore({
      namespace
    }).open();
    storeInstances.set(namespace, instance);
  }
  return instance;
}
export function getSuperStoreValue(namespace, key) {
  return getStore(namespace).then(store => store.get(key));
}
export function setSuperstoreValue(namespace, key, value) {
  return getStore(namespace).then(store => store.set(key, value));
}
export function wipeSuperstore(namespace) {
  return getStore(namespace).then(store => store.clear());
}